import { useState } from 'react';
import './index.css';
import Modal from 'components/Modal';
import Finder from '../Finder';

const InputFinder = ({ produtos, closeModal }) => {
	const [hunterInput, setHunterInput] = useState('');

	return (
		<Modal closeModal={closeModal}>
			<div id='Header__Container__inputFinder'>
				<input id='hunter' type='text' value={hunterInput} onChange={(e) => setHunterInput(e.target.value)} placeholder='Digite o nome do produto' />
			</div>
			{hunterInput !== '' && (
				<div className='allHunts'>
					{hunterInput !== '' &&
						produtos
							.filter((e) => e.produto.toLowerCase().includes(hunterInput.toLowerCase()))
							.map((e) => {
								return <Finder produtos={produtos} closeModal={closeModal} key={`Found__${e._id}`} id={e._id} />;
							})}
				</div>
			)}
		</Modal>
	);
};

export default InputFinder;
